/** Match-media helper for dictionary feed table mobile layout. */
export const dictTableLayoutMixin = {
  data () {
    return {
      narrowTable: false
    }
  },
  mounted () {
    this._tableMq = window.matchMedia('(max-width: 767px)')
    this.narrowTable = this._tableMq.matches
    this._onTableMq = (event) => {
      this.narrowTable = event.matches
    }
    if (this._tableMq.addEventListener) {
      this._tableMq.addEventListener('change', this._onTableMq)
    } else {
      this._tableMq.addListener(this._onTableMq)
    }
  },
  beforeDestroy () {
    if (!this._tableMq) return
    if (this._tableMq.removeEventListener) {
      this._tableMq.removeEventListener('change', this._onTableMq)
    } else {
      this._tableMq.removeListener(this._onTableMq)
    }
  }
}
